<template>
  <header class="page-header sticky top-20 z-10 bg-white">
    <div
      class="page-header__main"
      :class="{ 'page-header__main--with-actions': hasActions }"
    >
      <div class="page-header__left">
        <slot name="left">
          <div class="flex flex-wrap items-center gap-x-4 gap-y-2">
            <div class="page-header__titles">
              <h1 class="page-header__title" :class="titleModifierClass">
                {{ title }}
              </h1>
              <p v-if="subtitle" class="page-header__subtitle">
                {{ subtitle }}
              </p>
            </div>
            <!-- Contenido opcional junto al título (p. ej. semana del proyecto) -->
            <slot name="title-append" />
          </div>
        </slot>
      </div>

      <div v-if="hasActions" class="page-header__actions">
        <slot />
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'PageHeader',

  props: {
    title: { type: String, default: '' },
    subtitle: { type: String, default: '' },
    variant: {
      type: String,
      default: 'default',
      validator: value => ['default', 'issue'].includes(value),
    },
  },

  computed: {
    hasActions() {
      const defaultSlot = this.$slots.default
      if (!defaultSlot) {
        return false
      }

      const vnodes = typeof defaultSlot === 'function' ? defaultSlot() : defaultSlot
      return vnodes.length > 0
    },

    titleModifierClass() {
      return this.variant === 'issue'
        ? 'page-header__title--issue'
        : 'page-header__title--default'
    },
  },
}
</script>

<style scoped>
.page-header__main {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.75rem 1rem;
  padding: 0.625rem 1rem;
  border-bottom: 1px solid rgb(173, 194, 234);
}

.page-header__main--with-actions {
  align-items: center;
}

.page-header__left {
  min-width: 0;
  flex: 0 1 auto;
}

.page-header__titles {
  min-width: 0;
}

.page-header__title {
  margin: 0;
  font-family: inherit;
  font-size: 1.25rem;
  font-weight: 700;
  line-height: 1.2;
  text-transform: uppercase;
}

.page-header__title--default {
  color: #7d99d4;
}

.page-header__title--issue {
  color: #ef5753;
}

.page-header__subtitle {
  margin: 0.125rem 0 0;
  font-family: inherit;
  font-size: 0.875rem;
  font-weight: 700;
  line-height: 1.3;
  color: #8795a1;
}

.page-header__actions {
  flex: 1 1 16rem;
  min-width: 0;
  display: flex;
  align-items: center;
  overflow: visible;
}
</style>
